module.exports = __webpack_public_path__ + "img/logo.090b6af2.svg";